import React, { useState } from "react";
import "./TeacherSelectionBar.css";

const DIGER_PAGES = ["trial-lessons"];

const TeacherSelectionBar = ({ activePage, setActivePage }) => {
  const showSyllabus = localStorage.getItem("showSyllabus") === "true";
  const [digerOpen, setDigerOpen] = useState(() => DIGER_PAGES.includes(activePage));

  const handleDigerToggle = () => setDigerOpen((p) => !p);

  const handleSubPage = (page) => {
    setActivePage(page);
    setDigerOpen(true);
  };

  return (
    <ul className="teacher-selection-bar list-unstyled m-0 p-0">
      <li
        className={`item px-3 py-2 rounded ${activePage === "profil" ? "active" : ""}`}
        onClick={() => setActivePage("profil")}
      >
        <i className="bi bi-person-lines-fill me-2"></i>
        <span>Profil</span>
      </li>

      <li
        className={`item px-3 py-2 rounded ${activePage === "groups" ? "active" : ""}`}
        onClick={() => setActivePage("groups")}
      >
        <i className="bi bi-people me-2"></i>
        <span>Qruplarım</span>
      </li>

      <li
        className={`item px-3 py-2 rounded ${activePage === "projects" ? "active" : ""}`}
        onClick={() => setActivePage("projects")}
      >
        <i className="bi bi-folder2-open me-2"></i>
        <span>Layihələr</span>
      </li>

      {showSyllabus && (
        <li
          className={`item px-3 py-2 rounded ${activePage === "syllabus" ? "active" : ""}`}
          onClick={() => setActivePage("syllabus")}
        >
          <i className="bi bi-book me-2"></i>
          <span>Sillabus</span>
        </li>
      )}

      {/* Digər — accordion */}
      <li className="diger-group">
        <div
          className={`item px-3 py-2 rounded diger-header ${DIGER_PAGES.includes(activePage) ? "diger-parent-active" : ""}`}
          onClick={handleDigerToggle}
        >
          <i className="bi bi-grid me-2"></i>
          <span style={{ flex: 1 }}>Digər</span>
          <i
            className={`bi bi-chevron-down diger-chevron ${digerOpen ? "open" : ""}`}
            style={{ fontSize: 12 }}
          />
        </div>

        <ul className={`diger-sub list-unstyled m-0 p-0 ${digerOpen ? "diger-sub--open" : ""}`}>
          <li
            className={`diger-sub-item px-3 py-2 rounded ${activePage === "trial-lessons" ? "active" : ""}`}
            onClick={() => handleSubPage("trial-lessons")}
          >
            <i className="bi bi-person-check-fill me-2"></i>
            <span>Sınaq Dərslərim</span>
          </li>
        </ul>
      </li>
    </ul>
  );
};

export default TeacherSelectionBar;
